import { Part, PartProduct } from '@entities/Product';
import { PopupRemainder } from '../PopupRemainder';
import { IPopup } from '../TypeProps';

import styles from './PopupCondition.module.scss';

export const PopupCondition = ({ part, countLimit, max, allQuantity, onClose }: IPopup) => {
  if ([Part.Tyres, PartProduct.Tyres, Part.Disks, PartProduct.Disks].includes(part) && countLimit) {
    if (max < 4) {
      return (
        <PopupRemainder
          max={max}
          part={part}
          className={[Part.Tyres, PartProduct.Tyres].includes(part) ? styles.TooltipPopupTire : styles.TooltipPopupDisks}
          text={
            <p>
              Товар заканчивается. Если вам нужен комплект, посмотрите похожие товары
              {[Part.Tyres, PartProduct.Tyres].includes(part) ? ':' : '.'}
            </p>
          }
          onClose={onClose}
        />
      );
    } else {
      return (
        <PopupRemainder
          className={styles.TooltipPopup}
          text={
            <p>
              Нельзя купить больше. <br /> В наличии {allQuantity || max} шт.
            </p>
          }
          onClose={onClose}
        />
      );
    }
  }
  return null;
};
